import type {
  RestAPIActionCriteria,
  RestApiActionStatusCountResponse,
  RestAPIAddedActionResponse,
} from '@/interfaces/ApiRest.generated.interfaces'
import type { ServiceResponse } from '@/contexts/shared/service-response/ServiceResponse.interfaces'
import type { CreateActionPayload, ActionCreateResponse } from '@/contexts/actions/Actions.interfaces'
import { serviceError, serviceSuccess } from '@/contexts/shared/service-response/ServiceResponse.helpers'
import { useApiRest } from '@/contexts/shared/api/UseApiRest.composables'
import { createActionToApi, actionCreateResponseFromApi } from '@/contexts/actions/Actions.services.helpers'

export const createAction = async (payload: CreateActionPayload): Promise<ServiceResponse<ActionCreateResponse>> => {
  const url = 'v2/actions'
  const {
    ok,
    code,
    data: response,
  } = await useApiRest.post<RestAPIAddedActionResponse, RestAPIActionCriteria>(url, {
    body: createActionToApi(payload),
  })

  if (!ok) {
    return serviceError(code, response?.errors)
  }

  return serviceSuccess(actionCreateResponseFromApi(response.data))
}

export const getActionsInReviewCount = async (): Promise<ServiceResponse<number>> => {
  const url = '/v2/actions/to_review_count'
  const { ok, code, data: response } = await useApiRest.get<RestApiActionStatusCountResponse>(url)

  if (!ok) {
    return serviceError(code)
  }

  return serviceSuccess(response.count)
}
